import {createArray} from "@Common/utils/collections";
import {waitTimeout} from "@Common/utils/wait-timeout";

export const createMockListingsApis = () => ({
    getMyListings: async ({filter, limit, allListingsSearch, emulation, sorting, skip}) => {
        const result = require("./listing.json");
        return {
            ...result,
            records: createArray(10).map((id) => ({
                ...result.records[0],
                id,
            })),
        };
    },
    getListing: async (id) => {
        const result = require("./listing.json");
        return result.records[0];
    },
    getCleanUserPrefs: async () => {
        // await waitTimeout(500);
        return require("./sample-user-prefs");
    },
    saveCleanUserPrefs: async (data) => {
        console.log("saveCleanUserPrefs");
        await waitTimeout(200);

        return data;
    },
    getProgramPrefs: async () => {
        // await waitTimeout(500);
        return require("./sample-program-prefs");
    },
    getRule: async (ruleId) => {
        return {};
    },


    enrollment: {
        getUserEnrollments: async () => {
            console.log("getUserEnrollments", );
            // await waitTimeout(200);
            // return [];
            // return null;
            const ret = [require("./sample-user-enrollment.js")];
            if (!ret[0]) {
                return [];
            }
            if (temp) {
                ret[0].user_prog_prefs.enrolled = true;
            }
            temp = !temp;
            return ret;
        },
        saveUserEnrollment: async (enrollment, {newEnrollment=false}={}) => {
            console.log("API: saveUserEnrollment", enrollment);
            // throw {
            //     error: {
            //         message: "Already enrolled!",
            //         name: "BadRequestError",
            //         statusCode: 400,
            //     },
            // };


            await waitTimeout(600);
            if (newEnrollment) {
                enrollment = {...enrollment,enrolled: true};
            }
            // return require("./sample-user-enrollment");
            return {...enrollment, _id: "123",};
        },
        getProgram: async () => {
            // await waitTimeout(300);
            return require("./sample-enrollment-program");
        },
        getHistoricRuns: async () => {
            // return null;
            // scheduled-campaigns/past-runs/
            // await waitTimeout(300);
            return require("./sample-sc-past-runs.js");
        },
    },
});

let temp = false;
